<template>
	<el-descriptions style="margin-top: 20px;margin-bottom: 20px;" size="mini" class="margin-top" title="申请信息" border>
		<el-descriptions-item v-if="biao.type">
			<template slot="label">
				<i class="el-icon-paperclip"></i>
				家庭经济状况
			</template>
			{{biao.type}}
		</el-descriptions-item>
		<el-descriptions-item v-if="biao.yibao">
			<template slot="label">
				医保情况
			</template>
			{{biao.yibao}}
		</el-descriptions-item>
	<el-descriptions-item v-if="biao.qijus">
		<template slot="label">
			申请器具类型
		</template>
		<span style="margin-left: 10px;margin-right: 10px;" v-for="(p,i) in biao.qijus" :key="i">{{p}}</span>
	</el-descriptions-item>
	<el-descriptions-item v-if="biao.beizhu">
		<template slot="label">
			详细信息
		</template>
		{{biao.beizhu}}
	</el-descriptions-item>
	</el-descriptions>
</template>

<script>
	export default{
		data(){
			return{
				
			}
		},
		computed:{
			cjtypes(){
				
				return this.biao.cjtypes;
			}
			
		},
		watch:{
			biao(){
			  	
			}
		},
		props:["biao"],
		created() {
			
		}
	}
</script>

<style>
</style>
